// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2vU6i","signatureBlock":"Footer_signatureBlock__3XHiu","signature":"Footer_signature__2g6Ro"};